import React from 'react';
import { Icon } from 'antd';

export default function MockBanner({ children }) {
  return (
    <div className="testing-exercising-mock-banner" role="status">
      <Icon type="experiment" aria-hidden />
      <span>{children}</span>
    </div>
  );
}
